const assign = require('lodash/assign');

const LEVELS_DESCRIPTORS = [
  { name: 'NONE', value: 0, method: null },
  { name: 'ERROR', value: 1, method: 'error' },
  { name: 'WARN', value: 2, method: 'warn' },
  { name: 'INFO', value: 3, method: 'info' },
  { name: 'LOG', value: 4, method: 'log' },
  { name: 'DEBUG', value: 5, method: 'debug' },
  { name: 'SPAM', value: 6, method: 'spam' },
];

function noop() {}

/**
 * Creates a logging method that retains as much context as possible.
 *
 * In IE it creates a function that formats data better. In other browsers it returns a function
 * bound to the console to keep the file/line debugging info.
 */
function createLoggingMethod(obj, methodName) {
  return (...args) => {
    obj[methodName](...args);
  };
}

function getLoggingMethod(methodName) {
  if (typeof console === 'undefined') {
    return noop;
  }

  if (console[methodName] !== undefined) {
    return createLoggingMethod(console, methodName);
  }

  if (console.log !== undefined) {
    return createLoggingMethod(console, 'log');
  }

  return noop;
}

function assignLoggingMethods(obj, level) {
  const mixin = {};

  LEVELS_DESCRIPTORS.forEach((levelDescriptor) => {
    mixin[levelDescriptor.name] = levelDescriptor.value;
  });

  LEVELS_DESCRIPTORS.forEach((levelDescriptor) => {
    if (levelDescriptor.method !== null) {
      if (levelDescriptor.value <= level) {
        mixin[levelDescriptor.method] = getLoggingMethod(levelDescriptor.method);
      } else {
        mixin[levelDescriptor.method] = noop;
      }
    }
  });

  mixin.debug(`Setting the debug level to ${level}`);
  assign(obj, mixin);
}

// This logging mixin is based on the idea that to get correct file / line info in log trace we
// need direct console method call. To ensure that we need to implement logging level filtering by
// rebinding method every time it changes: we can't wrap logging methods to filter otherwise we
// would lose the file/line info
module.exports = function applyLoggerMixin(logging) {
  const mixin = {};

  // Dead code. Should be removed in v3
  mixin.shouldLog = noop;
  mixin.setLogLevel = function setLogLevel(levelParam) {
    // make sure the level value is a valid one
    const level = typeof levelParam === 'number' ? levelParam : 0;
    assignLoggingMethods(logging, level);
    return level;
  };

  assign(logging, mixin);
  logging.setLogLevel(logging.ERROR);
};



// WEBPACK FOOTER //
// ./src/js/common-js-helpers/logging/mixin.js